var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeaderboard1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 10.5001H5.25016C4.47661 10.5001 3.73475 10.1928 3.18777 9.64581C2.64079 9.09883 2.3335 8.35696 2.3335 7.58341C2.3335 6.80987 2.64079 6.068 3.18777 5.52102C3.73475 4.97404 4.47661 4.66675 5.25016 4.66675H7.00016",
    stroke: "#FFD700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5001H22.75C23.5235 10.5001 24.2654 10.1928 24.8124 9.64581C25.3594 9.09883 25.6667 8.35696 25.6667 7.58341C25.6667 6.80987 25.3594 6.068 24.8124 5.52102C24.2654 4.97404 23.5235 4.66675 22.75 4.66675H21",
    stroke: "#FFD700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 25.6667H23.3332",
    stroke: "#FFD700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 17.1033V19.8333C11.6665 20.4749 11.1182 20.9766 10.5348 21.2449C9.15817 21.8749 8.1665 23.6133 8.1665 25.6666",
    stroke: "#FFD700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 17.1033V19.8333C16.3335 20.4749 16.8818 20.9766 17.4652 21.2449C18.8418 21.8749 19.8335 23.6133 19.8335 25.6666",
    stroke: "#FFD700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.33325H7V10.4999C7 12.3564 7.7375 14.1369 9.05025 15.4497C10.363 16.7624 12.1435 17.4999 14 17.4999C15.8565 17.4999 17.637 16.7624 18.9497 15.4497C20.2625 14.1369 21 12.3564 21 10.4999V2.33325Z",
    stroke: "#FFD700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaderboard1St);
export default __webpack_public_path__ + "static/media/icon-leaderboard-1st.5e974b862d89368dd20a3596404dd97c.svg";
export { ForwardRef as ReactComponent };